import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { UiMask } from '../styled';

const aniToast = keyframes`
  from{
    transform: translate(-50%, -100px);
    opacity: 0;
  }
  to{
    opacity: 1;
    transform: translate(-50%, 20px);
  }
`;

const aniRoomToast = keyframes`
  from{
    transform: translate(-50%, -100px);
    opacity: 0;
  }
  to{
    opacity: 1;
    transform: translate(-50%, 0);
  }
`;

const aniLoading = keyframes`
  from{
    transform: rotate(0);
  }
  to{
    transform: rotate(360deg);
  }

`;

let Mask = styled(UiMask)`
  z-index: ${(props) => props.theme.zIndex.toastMask};
`;

let Wrap = styled.div`
  color: ${(props) => props.theme.color.second};

  .toast-bd {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 10px 15px 10px;
    min-height: 40px;
    background-color: #fff;
    z-index: ${(props) => props.theme.zIndex.toast};
    font-size: 14px;
    border-radius: 6px;
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.4);
    animation: ${aniToast} 0.4s linear forwards;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.color.dark};
  }

  .toast-icon {
    font-size: 32px;
    margin-right: 10px;
    width: 32px;
    line-height: 32px;
    text-align: center;
    height: 32px;

    &.success .iconfont {
      font-size: 32px;
      color: ${(props) => props.theme.color.success};
    }

    &.fail .iconfont {
      font-size: 32px;
      color: ${(props) => props.theme.color.warn};
    }

    &.info .iconfont {
      font-size: 32px;
      color: ${(props) => props.theme.color.info};
    }

    &.loading {
      animation: ${aniLoading} linear 1s infinite;

      .iconfont {
        font-size: 32px;
        color: ${(props) => props.theme.color.info};
      }
    }
  }

  .toast-content {
    //max-width: 300px;
    line-height: 20px;

    .remark {
      font-size: 12px;
      padding-top: 2px;
      min-width: 200px;
    }
  }

  &.clientRoom {
    .toast-bd {
      position: absolute;
      top: auto;
      bottom: 0;
      padding: 12px 12px;
      background: rgba(51, 57, 64, 0.85);
      color: #fff;
      line-height: 1;
      min-height: auto;
      white-space: nowrap;
      animation: ${aniRoomToast} 0.4s linear forwards;

      &.fail {
        background-color: rgba(255, 0, 0, 0.85);
      }

      &.success {
        background-color: rgba(68, 215, 182, 0.85);
      }

      &.info {
        background-color: rgba(255, 158, 13, 0.85);
      }
    }

    .toast-icon {
      display: none;
    }
  }
`;

export { Wrap, Mask };
